import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const ShopSection = () => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("/assets/data/hp-products.json")
      .then((res) => res.json())
      .then((data) => setProducts(data))
      .catch((err) => console.error("Error loading products:", err));
  }, []);

  const handleAddToCart = (product) => {
    const loggedIn = sessionStorage.getItem("isLoggedIn");
    if (loggedIn !== "true") {
      toast.error("Please login first!");
      navigate("/login");
      return;
    }

    let cart = JSON.parse(sessionStorage.getItem("cart")) || [];
    const exists = cart.find((i) => i.id === product.id);
    exists ? (exists.quantity += 1) : cart.push({ ...product, quantity: 1 });
    sessionStorage.setItem("cart", JSON.stringify(cart));
    toast.success(`${product.name} added to cart`);
  };

  return (
    <section className="sx-shop">
      <div className="sx-shop-container">
        {/* HEADER */}
        <div className="sx-shop-head">
          <h2>Our Printers</h2>
          <span>{products.length} products available</span>
        </div>

        {/* GRID */}
        <div className="sx-shop-grid">
          {products.map((item) => {
            const shortDesc =
              item.description?.split(" ").slice(0, 14).join(" ") + "...";
            const rating = (Math.random() * 1 + 4).toFixed(1);

            return (
              <div className="sx-product-card" key={item.id}>
                {/* IMAGE */}
                <Link to={`/product/${item.id}`} className="sx-product-image">
                  <img src={item.imageUrl} alt={item.name} />
                </Link>

                {/* INFO */}
                <div className="sx-product-info">
                  <span className="sx-product-category">
                    {item.category.replace(/-/g, " ")}
                  </span>

                  <Link to={`/product/${item.id}`}>
                    <h3 className="sx-product-title">{item.name}</h3>
                  </Link>

                  <p className="sx-product-desc">{shortDesc}</p>

                  <div className="sx-product-meta">
                    <span className="sx-rating">★ {rating}</span>
                    <span className="sx-stock">In Stock</span>
                  </div>

                  <div className="sx-product-bottom">
                    <span className="sx-price">${item.price}</span>
                    <button
                      className="sx-cart-btn"
                      onClick={() => handleAddToCart(item)}
                    >
                      Add to Cart
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* CSS */}
      <style>{`
        /* ================= SHOP ================= */
        .sx-shop {
          padding: 90px 0;
          background: #f7f9fc;
        }

        .sx-shop-container {
          max-width: 1300px;
          margin: auto;
          padding: 0 20px;
        }

        /* HEADER */
        .sx-shop-head {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 40px;
        }

        .sx-shop-head h2 {
          font-size: 32px;
          font-weight: 800;
          color: #111;
        }

        .sx-shop-head span {
          font-size: 14px;
          color: #6b7280;
        }

        /* GRID */
        .sx-shop-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
          gap: 28px;
        }

        /* CARD */
        .sx-product-card {
          background: #ffffff;
          box-shadow: 0 8px 30px rgba(0,0,0,0.08);
          transition: transform .25s ease, box-shadow .25s ease;
        }

        .sx-product-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 18px 45px rgba(0,0,0,0.15);
        }

        /* IMAGE */
        .sx-product-image {
          display: flex;
          justify-content: center;
          padding: 24px;
          background: #f1f4fb;
        }

        .sx-product-image img {
          width: 85%;
          height: 200px;
          object-fit: contain;
        }

        /* INFO */
        .sx-product-info {
          padding: 20px;
        }

        .sx-product-category {
          font-size: 11px;
          text-transform: uppercase;
          letter-spacing: 1px;
          color: #0b5ed7;
          font-weight: 700;
        }

        .sx-product-title {
          font-size: 17px;
          font-weight: 700;
          color: #111;
          margin: 8px 0;
          line-height: 1.4;
        }

        .sx-product-desc {
          font-size: 14px;
          color: #555;
          line-height: 1.6;
          margin-bottom: 14px;
        }

        /* META */
        .sx-product-meta {
          display: flex;
          gap: 14px;
          font-size: 13px;
          margin-bottom: 16px;
        }

        .sx-rating {
          color: #f59e0b;
          font-weight: 700;
        }

        .sx-stock {
          color: #16a34a;
          font-weight: 700;
        }

        /* BOTTOM */
        .sx-product-bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .sx-price {
          font-size: 22px;
          font-weight: 800;
          color: #111;
        }

        .sx-cart-btn {
          background: #111;
          color: #fff;
          border: none;
          padding: 10px 18px;
          font-size: 14px;
          font-weight: 700;
          cursor: pointer;
          transition: background .25s ease;
        }

        .sx-cart-btn:hover {
          background: #000;
        }

        /* MOBILE */
        @media(max-width: 600px) {
          .sx-shop-head {
            flex-direction: column;
            align-items: flex-start;
            gap: 8px;
          }
        }
      `}</style>
    </section>
  );
};

export default ShopSection;
